/**
 * 
 * Autocomplete is now lazy loaded based on user interaction with an element in the DOM
 * which is to have the autocomplete functionality bound to it.
 * 
 * This core file is required into the javascript workflow via the global configuration object
 * (window.oneadvanced.required.autocomplete = true) in any of the corresponding View files in which
 * their component will want autocomplete functionality.
 * 
 * Then in order to signal to the autocomplete core code that a specific element requires
 * autocomplete functionality, it can be added to a queue within the global configuration object
 * (window.oneadvanced.autocomplete.queue). Again this is added in the associated View code where
 * the element's selector is pushed onto the queue (the queue being an Array).
 * 
 * The selector itself should be in the exact format needed for jQuery to wrap it as an object;
 * for example '#Search-Page-Filter' for an element whose id attribute is equal to 'Search-Page-Filter'.
 * 
 * Autocomplete core will bind event listeners to the 'focus' event of each of the elements in the previously
 * mentioned queue.
 * 
 * A check will be made to detect if autocomplete functionality is already present and if it is not, then
 * the autocomplete javascript file will be loaded and an event will fire after successfull loading of the script
 * to kick off the binding of autocomplete functionality to each element as required.
 * A map will hold a record of which elements have already had autocomplete bound to them and this will be checked
 * before any rebinding takes place.
 * 
 * Additionally, jQuery UI's autocomplete is loaded with EPiServer Forms so the the check for autocomplete is based not
 * only on our own flag for signalling if we've loaded it, but also if it has been loaded by other actors in the codebase.
 * However, as the majority of our forms are now loaded into iframes, this prevents the form's version of autocomplete
 * from being accessed by the parent page, thus forcing us to essentially load autocomplete twice.
 * 
 **/

(function () {

    window.oneadvanced = window.oneadvanced || {};
    window.oneadvanced.autocomplete = window.oneadvanced.autocomplete || {};
    window.oneadvanced.autocomplete.hasLoaded = window.oneadvanced.autocomplete.hasLoaded || false;
    window.oneadvanced.autocomplete.script = window.oneadvanced.autocomplete.script || {};
    window.oneadvanced.autocomplete.script.hasLoaded = window.oneadvanced.autocomplete.script.hasLoaded || false;
    window.oneadvanced.autocomplete.queue = window.oneadvanced.autocomplete.queue || [];
    window.oneadvanced.autocomplete.hasAttached = window.oneadvanced.autocomplete.hasAttached || new Map();

    window.oneadvanced.autocomplete.loadAutocomplete = function () {

        // console.log("loadAutocomplete running...");
        if (!(typeof $.fn.autocomplete == 'function' || window.oneadvanced.autocomplete.script.hasLoaded)) {

            // console.log("autocomplete loading...");
            var jqueryUIScript = document.createElement("script");
            jqueryUIScript.setAttribute("src", window.location.origin + "/Static/cdn/jquery-ui-1.13.0.min.js");
            document.body.appendChild(jqueryUIScript);

            jqueryUIScript.addEventListener("load", function () {
                window.oneadvanced.autocomplete.script.hasLoaded = true;
                const autocompleteLoadedEvent = new Event('autocompleteLoaded');
                document.dispatchEvent(autocompleteLoadedEvent);
            }, false);
        }
        else {
            // console.log("autocomplete already loaded.");
            const autocompleteLoadedEvent = new Event('autocompleteLoaded');
            document.dispatchEvent(autocompleteLoadedEvent);
        }
    }

    window.oneadvanced.autocomplete.attachAutocomplete = function ($jQueryElements) {

        // console.log("attachAutocomplete running...");
        document.removeEventListener("autocompleteLoaded", window.oneadvanced.autocomplete.attachAutocomplete, false);

        $jQueryElements.each(function () {

            var $this = $(`${this}`);
            var $thisName = JSON.stringify(this);

            if (!window.oneadvanced.autocomplete.hasAttached.has($thisName)) {

                // console.log("autocomplete attaching to " + $this + "...");
                $this.autocomplete({
                    source: function (request, response) {
                        $.ajax({
                            url: "/find_v2/_autocomplete?prefix=" + encodeURIComponent(request.term) + "&size=5",
                            dataType: "jsonp",
                            contentType: 'application/json; charset=utf-8',
                            success: function (data) {
                                response($.map(data.hits, function (item) {
                                    return {
                                        label: item.query,
                                        value: item.query
                                    };
                                }));
                            }
                        });
                    },
                    minLength: 2
                });

                window.oneadvanced.autocomplete.hasAttached.set($thisName, $(this));
            }
        });
    }

    window.oneadvanced.autocomplete.init = function () {

        // console.log("initialising autocomplete...");
       var $queue = $(window.oneadvanced.autocomplete.queue);
        $queue.each(function () {
            $(this.toString()).one("focus", window.oneadvanced.autocomplete.loadAutocomplete);
        });

        document.addEventListener("autocompleteLoaded", window.oneadvanced.autocomplete.attachAutocomplete.bind(this,$queue), false);
    };

    window.oneadvanced.autocomplete.hasLoaded = true;
})();